import replaceAll from './replaceAll'
/**
 * Function to sort the dataSource, by default it sort the data in ascending order.
 * @param  {Object} data
 * @param  {string} fields
 * @param  {boolean} isDescending
 * @returns Object
 */
export default function sort(data, fields, isDescending = true) {
	let sortData = data
	const getValue = value => {
		if (typeof value === 'string') {
			return +replaceAll(value, ',', '')
		} else {
			return +value
		}
	}
	sortData.sort((a, b) => {
		let first = 0
		let second = 0
		for (let i = 0; i < fields.length; i++) {
			first += getValue(a[fields[i]])
			second += getValue(b[fields[i]])
		}
		if ((!isDescending && first < second) || (isDescending && first > second)) {
			return -1
		} else if (first === second) {
			return 0
		}
		return 1
	})
	return sortData
}
